export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";